<template>
  <div style="overflow-y: auto">
    <div class="pl-1">
      <v-progress-linear
        indeterminate
        color="primary"
        class="pl-1"
        v-if="calculationIsLoading"
      ></v-progress-linear>
    </div>
    <span v-if="calculations.length === 0 && !calculationIsLoading">
      <v-alert outlined color="primary" class="ma-1">
        {{ $t("common.no_data_available") }}
      </v-alert>
    </span>
    <v-simple-table v-else height="211">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">#</th>
            <th class="text-left">{{ $t("common.name") }}</th>
            <th class="text-left">{{ $t("common.customer") }}</th>
            <th class="text-left">{{ $t("common.car") }}</th>
            <th class="text-left">{{ $t("common.total_sum") }}</th>
            <th class="text-left">
              {{ $t("common.date") }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="calculation in calculations.slice(0, limit)" :key="calculation.id">
            <td>
              <span class="dashed" @click="$router.push({ name: 'calculations', params: { id: calculation.id } })">
              {{calculation.id}}
                </span>
            </td>
            <td>
              {{calculation.name}}
            </td>
            <td>
              {{calculation.customer && calculation.customer.full_name}}
              {{
                calculation && calculation.customer && calculation.customer.is_company == 1
                    ? "[" + calculation.customer.legal_name + "]"
                    : ""
              }}
            </td>
            <td>

              <template v-if="calculation.car">
                <div class="d-inline">
                  <img
                    align="center"
                    class="brandLogoMiddle mr-1"
                    v-if="!!brandURL(calculation.car.brand)"
                    :src="brandURL(calculation.car.brand)"
                    :title="calculation.car && calculation.car.brand && calculation.car.brand.toUpperCase()"
                  />
                  <span v-else>
                    {{ calculation.car && calculation.car.brand.toUpperCase() }}
                  </span>
                </div>

                <span
                  class="mr-2"
                  >{{ calculation.car.brand }} {{ calculation.car.family }} {{ calculation.car.model }}</span
                >
                <beauty-car-number
                  :number="calculation.car.car_number ? calculation.car.car_number : ''"
                  class="small"
                />
              </template>
            </td>
            <td>
              {{formatCurrency(calculation.total_sum)}}
            </td>
            <td>
              <span class="text-caption"
                >{{ calculation.created_at | moment("DD.MM.YYYY") }}
                {{ calculation.created_at | moment("HH:mm") }}</span
              >
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import CarForm from "@/components/garage/CarForm.vue";
import BeautyCarNumber from "@/components/common/BeautyCarNumber.vue";
import CommonMixin from "@/mixins/common";

export default {
  name: "MainWidgetCalculations",
  components: { BeautyCarNumber, CarForm },
  mixins: [CommonMixin],
  props: {
    limit: {
      type: Number,
      default: 5,
    },
  },
  data: () => ({
    carWin: {
      isVisible: false,
      carId: null,
    },
  }),
  computed: {
    ...mapFields("cart", [
      "calculations",
      "calculation",
      "calculationIsLoading",
    ]),
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.$store.dispatch("cart/getCalculations");
    },
  },
};
</script>

<style scoped>
.brandLogoMiddle {
  width: 16px;
}
</style>
